import { render, staticRenderFns } from "./_base-course-dashboard-overview.vue?vue&type=template&id=01ec7f78"
import script from "./_base-course-dashboard-overview.vue?vue&type=script&lang=js"
export * from "./_base-course-dashboard-overview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports